import React, { useEffect, useState } from "react";
import { Table, Button, Space } from "antd";
import { get, del } from "../API/api_helper";
import Swal from "sweetalert2";
import GradeModal from "../Modals/GradeModal";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";

interface Grade {
  id: number;
  grade: string;
}

const GradePage: React.FC = () => {
  const [grades, setGrades] = useState<Grade[]>([]);
  const [showGradeModal, setShowGradeModal] = useState(false);
  const [editingGrade, setEditingGrade] = useState<Grade | null>(null);

  const fetchGrades = async () => {
    try {
      const res = await get("/grades");
      setGrades(res.data || res);
    } catch (err) {
      console.error("Failed to fetch grades", err);
    }
  };

  useEffect(() => {
    fetchGrades();
  }, []);

  const handleDelete = async (id: number) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This grade will be deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });
    if (confirm.isConfirmed) {
      await del(`/grades/${id}`);
      Swal.fire("Deleted!", "Grade deleted.", "success");
      fetchGrades();
    }
  };

  const columns = [
    { title: "Grade", dataIndex: "grade" },
    {
      title: "Actions",
      render: (_: any, record: Grade) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => {
              setEditingGrade(record);
              setShowGradeModal(true);
            }}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={() => handleDelete(record.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="p-4">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <h2 style={{ fontSize: "25px" }}>Grade Management</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setEditingGrade(null); // reset
            setShowGradeModal(true);
          }}
        >
          Add Grade
        </Button>
      </div>

      <Table
        dataSource={grades}
        columns={columns}
        rowKey="id"
        pagination={false}
      />

      {showGradeModal && (
        <GradeModal
          show={showGradeModal}
          onHide={() => setShowGradeModal(false)}
          editingGrade={editingGrade}
          onSaved={() => {
            fetchGrades();
            setShowGradeModal(false);
          }}
        />
      )}
    </div>
  );
};

export default GradePage;
